/*********************************************************************************
 * This is `select` from ngrx/store pulled out into a pipeable operator with the *
 * the type definitions fixed as per https://github.com/ngrx/platform/issues/528 *
 ********************************************************************************/
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as Rx from 'rxjs';
import { distinctUntilChanged, map, pluck } from 'rxjs/operators';
export function select(pathOrMapFn) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    if (typeof pathOrMapFn === 'string') {
        return Rx.pipe(pluck.apply(void 0, __spreadArrays([pathOrMapFn], paths)), distinctUntilChanged());
    }
    if (typeof pathOrMapFn === 'function') {
        return Rx.pipe(map(pathOrMapFn), distinctUntilChanged());
    }
    throw new TypeError("Unexpected type '" + typeof pathOrMapFn + "' in select operator," +
        " expected 'string' or 'function'");
}
